/* ============================================================
   HerbalVap Dawn theme — global.js (S2)
   Interactions: age-gate, scroll reveal, hero parallax, bottom
   sheet (drag-to-dismiss), testimonial rotation, blends touch-active,
   cart badge. No runtime content injection (all server-rendered).
   NOTE: age-gate + sheet are prototype placeholders; production swaps in
   AgeChecker/Veratad (C9). Cart is implemented via branded /cart template
   (main-cart.liquid) + AJAX add; Recharge subscription (C1/C2) still pending.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- spring helper (interruptible) ---------- */
  function spring(opts) {
    if (reduce) { opts.onUpdate(opts.to); if (opts.onRest) opts.onRest(); return function () {}; }
    var x = opts.from, v = opts.velocity || 0, raf = 0, dt = 1 / 60;
    function step() {
      var a = (-opts.stiffness * (x - opts.to) - opts.damping * v) / (opts.mass || 1);
      v += a * dt; x += v * dt; opts.onUpdate(x);
      if (Math.abs(v) < 0.08 && Math.abs(x - opts.to) < 0.08) { opts.onUpdate(opts.to); if (opts.onRest) opts.onRest(); return; }
      raf = requestAnimationFrame(step);
    }
    raf = requestAnimationFrame(step);
    return function () { cancelAnimationFrame(raf); };
  }
  function rubberband(o, dim, c) { c = c || 0.55; return (o * dim * c) / (dim + c * Math.abs(o)); }

  /* ---------- age gate (storefront pre-screen; checkout layer = AgeChecker app) ---------- */
  function initGate() {
    var gate = document.getElementById('gate');
    if (!gate) return;
    var enter = document.getElementById('enter');
    try { if (sessionStorage.getItem('hv_age_verified')) { gate.style.display = 'none'; return; } } catch (e) {}
    document.body.style.overflow = 'hidden'; // lock scroll while gated
    if (enter) enter.focus();
    function dismiss() {
      try { sessionStorage.setItem('hv_age_verified', '1'); } catch (e) {}
      document.body.style.overflow = '';
      if (reduce) { gate.style.display = 'none'; return; }
      spring({
        from: 1, to: 0, stiffness: 200, damping: 22,
        onUpdate: function (s) { gate.style.opacity = s; gate.style.transform = 'scale(' + (0.96 + 0.04 * s) + ')'; },
        onRest: function () { gate.style.display = 'none'; }
      });
    }
    if (enter) enter.addEventListener('click', dismiss);
  }

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        setTimeout(function () { el.classList.add('is-in'); }, +(el.dataset.delay || 0));
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(targets, function (el, i) {
      el.dataset.delay = (i % 6) * 60;
      io.observe(el);
    });
  }

  /* ---------- hero pointer parallax ---------- */
  function initHeroParallax() {
    var hero = document.querySelector('.hero');
    var heroV = document.getElementById('heroVisual');
    if (reduce || !hero || !heroV || !window.matchMedia('(pointer:fine)').matches) return;
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
    function loop() {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      heroV.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)';
      if (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) raf = requestAnimationFrame(loop);
    }
    hero.addEventListener('pointermove', function (e) {
      var r = heroV.getBoundingClientRect();
      tx = ((e.clientX - (r.left + r.width / 2)) / r.width) * 18;
      ty = ((e.clientY - (r.top + r.height / 2)) / r.height) * 18;
      cancelAnimationFrame(raf); raf = requestAnimationFrame(loop);
    });
  }

  /* ---------- bottom sheet (drag-to-dismiss) ---------- */
  function initSheet() {
    var sheet = document.getElementById('sheet');
    var back = document.getElementById('sheetBackdrop');
    var grab = document.getElementById('sheetGrab');
    var openBtn = document.getElementById('openSheet');
    var cta = document.getElementById('sheetCta');
    if (!sheet || !back) return;
    var sheetY = 0, open = false, drag = false, startY = 0, lastY = 0, lastT = 0, vel = 0, pid = 0;
    function H() { return sheet.offsetHeight; }
    function to(px) { sheetY = px; sheet.style.transform = 'translateY(' + px + 'px)'; }
    function openSheet() {
      open = true; back.classList.add('show'); sheet.setAttribute('aria-hidden', 'false');
      if (reduce) { to(0); return; }
      spring({ from: H(), to: 0, stiffness: 200, damping: 24, onUpdate: to });
    }
    function closeSheet() {
      open = false; back.classList.remove('show'); sheet.setAttribute('aria-hidden', 'true');
      if (reduce) { to(H()); return; }
      spring({ from: sheetY, to: H(), stiffness: 200, damping: 24, onUpdate: to, onRest: function () { sheet.style.transform = 'translateY(100%)'; } });
    }
    if (openBtn) openBtn.addEventListener('click', openSheet);
    back.addEventListener('click', closeSheet);
    if (cta) cta.addEventListener('click', function () {
      var lang = document.documentElement.lang;
      window.location.href = (lang && lang !== 'en') ? '/' + lang + '/pages/subscribe' : '/pages/subscribe';
    });
    if (grab) {
      grab.addEventListener('pointerdown', function (e) {
        drag = true; pid = e.pointerId; grab.setPointerCapture(pid);
        startY = e.clientY; lastY = e.clientY; lastT = performance.now(); vel = 0;
        sheet.style.transition = 'none';
      });
      grab.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dy = e.clientY - startY, ny = dy;
        if (ny < 0) ny = -rubberband(-ny, H() * 0.4);
        to(ny);
        var now = performance.now(), dt = now - lastT || 16;
        vel = (e.clientY - lastY) / dt; lastY = e.clientY; lastT = now;
      });
      function end() {
        if (!drag) return; drag = false;
        if (vel > 0.4 || sheetY > H() * 0.5) closeSheet();
        else { if (reduce) to(0); else spring({ from: sheetY, to: 0, stiffness: 200, damping: 24, onUpdate: to }); }
      }
      grab.addEventListener('pointerup', end);
      grab.addEventListener('pointercancel', end);
    }
  }

  /* ---------- testimonials (rotate from server JSON) ---------- */
  function initTestimonials() {
    var el = document.getElementById('reviewData');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    if (!data.length) {
      var _sec = document.querySelector('.t-section');
      if (_sec) { var _s = _sec.closest('section'); if (_s) _s.style.display = 'none'; }
      return;
    }
    var q = document.getElementById('tQuote'),
        by = document.getElementById('tBy'),
        score = document.getElementById('tScore'),
        prev = document.getElementById('tPrev'),
        next = document.getElementById('tNext');
    if (!q || !by || !score) return;
    var i = 0;
    function show(idx) {
      i = (idx + data.length) % data.length;
      var r = data[i];
      if (reduce) { q.textContent = r.q; by.textContent = r.a; score.textContent = r.score; return; }
      spring({ from: 14, to: 0, stiffness: 160, damping: 18, onUpdate: function (y) { q.style.opacity = String(1 - Math.abs(y) / 14); q.style.transform = 'translateY(' + y + 'px)'; }, onRest: function () { q.style.opacity = 1; } });
      spring({ from: 1, to: 0, stiffness: 200, damping: 20, onUpdate: function (s) { score.style.opacity = String(s); score.style.transform = 'translateY(' + (8 * (1 - s)) + 'px)'; }, onRest: function () { score.style.opacity = 1; } });
      q.textContent = r.q; by.textContent = r.a; score.textContent = r.score;
    }
    show(0);
    if (next) next.addEventListener('click', function () { show(i + 1); });
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
  }

  /* ---------- blends accordion (hover + tap to activate) ---------- */
  function initBlends() {
    var row = document.getElementById('blendsRow');
    if (!row) return;
    row.addEventListener('pointerdown', function (e) {
      var c = e.target.closest('.b-card');
      if (c) { row.querySelectorAll('.b-card').forEach(function (x) { x.classList.remove('active'); }); c.classList.add('active'); }
    });
    row.querySelectorAll('.b-card').forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        row.querySelectorAll('.b-card').forEach(function (x) { x.classList.remove('active'); });
        card.classList.add('active');
      });
    });
  }

  /* ---------- cart badge (Shopify cart object) ---------- */
  function initCart() {
    var badge = document.getElementById('cartBadge');
    if (badge && window.Shopify && Shopify.cart && Shopify.cart.item_count > 0) {
      badge.textContent = Shopify.cart.item_count;
      badge.classList.add('visible');
    }
  }

  /* ---------- product page (gallery / variant / qty) ---------- */
  function initProduct() {
    var form = document.getElementById('product-form');
    if (!form) return;

    /* thumbnail → main image swap */
    var mainImg = document.getElementById('pMainImg');
    var thumbs = form.querySelectorAll ? null : null;
    var thumbEls = document.querySelectorAll('.p-thumb');
    Array.prototype.forEach.call(thumbEls, function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.getAttribute('data-src');
        Array.prototype.forEach.call(thumbEls, function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });

    /* quantity stepper */
    var qty = document.getElementById('pQty');
    Array.prototype.forEach.call(document.querySelectorAll('.qty-btn'), function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var step = parseInt(b.getAttribute('data-step'), 10) || 0;
        var v = parseInt(qty.value, 10) || 1;
        v = Math.max(1, v + step);
        qty.value = v;
      });
    });

    /* variant radios → update hidden id + price */
    var variantsEl = document.getElementById('productVariants');
    var namesEl = document.getElementById('productOptionNames');
    if (!variantsEl || !namesEl) return;
    var variants, optionNames;
    try { variants = JSON.parse(variantsEl.textContent); optionNames = JSON.parse(namesEl.textContent); }
    catch (e) { return; }
    if (!variants.length) return;
    var idInput = document.getElementById('pVariantId');
    var priceEl = document.getElementById('pPrice');
    var radios = form.querySelectorAll('input[type="radio"][data-variant]');

    function handleize(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-'); }
    function selected() {
      var map = {};
      Array.prototype.forEach.call(radios, function (r) { if (r.checked) map[r.name] = r.value; });
      return map;
    }
    function matchVariant() {
      var sel = selected();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++) {
          var n = handleize(optionNames[j]);
          if (sel[n] !== v.options[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function update() {
      var v = matchVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && typeof v.price === 'number') {
        priceEl.textContent = '$' + (v.price / 100).toFixed(2);
      }
    }
    Array.prototype.forEach.call(radios, function (r) { r.addEventListener('change', update); });
    update();

    /* subscribe button → subscription explainer (Recharge not installed yet) */
    var subBtn = document.getElementById('pSub');
    if (subBtn) {
      subBtn.addEventListener('click', function () {
        var lang = document.documentElement.lang;
        window.location.href = (lang && lang !== 'en') ? '/' + lang + '/pages/subscribe' : '/pages/subscribe';
      });
    }

    /* AJAX add-to-cart; fall back to native submit on any failure */
    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name === 'add') {
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { form.submit(); });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGate();
    initReveal();
    initHeroParallax();
    initSheet();
    initTestimonials();
    initBlends();
    initCart();
    initProduct();
  });
})();
